// extracted by mini-css-extract-plugin
module.exports = {"center":"user-name_center__3Xv72","wrapper":"user-name_wrapper__co4no"};